// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js??ref--5-1!./iview.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../vue-style-loader/lib/addStylesClient.js")("6fed9e34", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/view-design/dist/styles/iview.css
// module id = 594
// module chunks = 8